import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DeleteOutlined, DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Table, Popconfirm, Popover
} from 'antd';
import 'moment/locale/zh-cn';
import cookie from "react-cookies";
const { Title,Text } = Typography;
const { Content } = Layout;


const handleOk = (id,value) => {
    setTimeout(() => {

        fetch("https://pd.pokemonbye.com:8084/api/setsellstockinv?inv="+value+"&id=" + id.id)
            .then(res => res.json())
            .then(
                (result) => {
                    window.location.reload();

                },
                (error) => {
                }
            )
    }, 1000);
};
const DecimalStep = (id) => {
    const [inputValue, setInputValue] = useState(0);
    const onChange = (value) => {
        if (isNaN(value)) {
            return;
        }
        setInputValue(value);
    };
    return (
        <>
            <p>设置当前类型产品库存（吨）</p>
            <Row>
                <Col span={12}>
                    <Slider
                        min={0}
                        max={100000}
                        onChange={onChange}
                        value={typeof inputValue === 'number' ? inputValue : 0}
                        step={1}
                    />
                </Col>
                <Col span={4}>
                    <InputNumber
                        min={0}
                        max={100000}
                        style={{
                            margin: '0 16px',
                        }}
                        step={0.1}
                        value={inputValue}
                        onChange={onChange}
                    />
                </Col>
            </Row>
            <Button type="default" size="small" onClick={() => handleOk(id.id,inputValue)}>
                保存
            </Button>
        </>
    );
};

const content = (id) => (
    <>
        <Space direction="vertical"
               style={{
                   width: 300,
               }}>
            <DecimalStep id={id}/>
        </Space>
    </>
);

const Go = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <Popover content={() => content(id)} title="设置库存" trigger="click">
            <Button>
                库存调整
            </Button>
        </Popover>
    );
};
const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '类型',
        dataIndex: 'stockname',
        key: 'stockname',
    },
    {
        title: '单价(元/吨)',
        dataIndex: 'stockprice',
        key: 'stockprice',
    },
    {
        title: '库存量(吨)',
        dataIndex: 'inv',
        key: 'inv',
    },
    {
        title: '功能',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <Go id={record.id}></Go>
            </Space>
        ),
    },
];

class PagePurInvs extends Component{


    constructor(props) {
        super(props);
        const userid = cookie.load('userId');
        this.state = {
            title: "库存管理",
            county: [],
            userid: userid,
            list: []
        };
    }

    componentDidMount() {
        fetch("https://pd.pokemonbye.com:8084/api/getsellstock")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    for (let i = 0; i < array.length; i++) {
                        array[i].key = i + 1
                        /*
                        array[i].href = "/pagesellman?id="+array[i].id;
                        array[i].type = array[i].type == 2 ? '袋装' : '散装';
                        */
                    }
                    this.setState({
                        isLoaded: true,
                        list: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Table bordered={true} columns={columns} dataSource={this.state.list}/>

                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PagePurInvs;


